module.exports = __webpack_public_path__ + "static/media/PaymentsIcon.5e47a941.svg";